import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { CommonResponseModel } from '@project-management-system/shared-models';
import * as moment from 'moment';
import { DataSource, getManager, Repository } from 'typeorm';
import { WhatsAppNotificationService } from '../../../../../../libs/shared-services/src/common/whatsapp-message';
import { GenericTransactionManager } from '../../../typeorm-transactions';
import { VendorsEntity } from '../../vendor-registration/entity/vendors.entity';
import { CreateJobworkDto } from './dto/job-work-creation-dto';
import { JobworkCreationEntity } from './entity/job-work-creation-entity';
import { JobWorkStatus, PriceNegotiationEntity } from './entity/price-negotiation-entity';
import { VendorReq } from './dto/vendor-req';
import { VendorStatusUpdateReq } from './dto/vendor-status-update-req';
import { JobworkIdReq } from './dto/job-work-id.req';

@Injectable()
export class JobworkCreationService {
    constructor(
        @InjectRepository(JobworkCreationEntity)
        private jobworkCreationRepository: Repository<JobworkCreationEntity>,
        @InjectRepository(PriceNegotiationEntity)
        private readonly priceNegotiationRepository: Repository<PriceNegotiationEntity>,
        @InjectRepository(VendorsEntity)
        private readonly vendorsRepository: Repository<VendorsEntity>,
        private wpService: WhatsAppNotificationService,
        private dataSource: DataSource,
        // private jobworkRepo: JobworkCreationRepository
    ) { }

    async createJobwork(req: CreateJobworkDto): Promise<CommonResponseModel> {
        const transactionalEntityManager = new GenericTransactionManager(this.dataSource);
        try {
            await transactionalEntityManager.startTransaction();

            const jobworkEntity = new JobworkCreationEntity();
            jobworkEntity.unit = req.unit;
            jobworkEntity.subJobId = req.subJobId;
            jobworkEntity.division = req.division;
            jobworkEntity.buyer = req.buyer;
            const formattedDate = moment(req.addOnQtyDate).format('YYYY-MM-DD');
            jobworkEntity.addOnQtyDate = new Date(formattedDate);
            jobworkEntity.addonOrderQty = req.addonOrderQty;
            jobworkEntity.itemNo = req.itemNo;
            jobworkEntity.styleNo = req.styleNo;
            jobworkEntity.noOfOperations = req.noOfOperations;
            jobworkEntity.operationType = req.operationType;
            jobworkEntity.ratePerGarment = req.ratePerGarment;
            jobworkEntity.totalOrderQty = req.totalOrderQty;
            jobworkEntity.createdUser = req.createdUser;
            jobworkEntity.versionFlag = req.versionFlag;
            jobworkEntity.updatedUser = req.updatedUser;

            const savedJobwork = await transactionalEntityManager.getRepository(JobworkCreationEntity).save(jobworkEntity);

            if (!savedJobwork) {
                return new CommonResponseModel(false, 0, 'Something went wrong in job work creation', []);
            }

            const approvedVendors = await transactionalEntityManager.getRepository(VendorsEntity).find({ where: { status: 'APPROVED' } });

            if (approvedVendors.length === 0) {
                return new CommonResponseModel(false, 0, 'No approved vendors available', []);
            }

            // Save price negotiation data for each approved vendor
            for (const vendor of approvedVendors) {
                const priceNegotiationEntity = new PriceNegotiationEntity();
                priceNegotiationEntity.vendorId = vendor.id;
                priceNegotiationEntity.vendor = vendor.vendorName;
                priceNegotiationEntity.shahiPrice = jobworkEntity.ratePerGarment;
                priceNegotiationEntity.vendorPrice = 0;
                priceNegotiationEntity.finalPrice = 0;
                priceNegotiationEntity.vendorAccepted = false;
                priceNegotiationEntity.jobWorkStatus = JobWorkStatus.PENDING;
                priceNegotiationEntity.jobworkId = savedJobwork;
                await transactionalEntityManager.getRepository(PriceNegotiationEntity).save(priceNegotiationEntity);
            }

            const approvedVendorss = await transactionalEntityManager.getRepository(VendorsEntity).find({
                select: ['phoneNumber', 'vendorName',],
                where: { status: 'APPROVED' }
            });

            const jobworkResult =
                `SELECT jw.name FROM job_work jw WHERE jw.id = '${req.subJobId}'`
            const jobworkName = jobworkResult[0];

            let messageStatus;
            let statusFlag = false;
            const addOnQtyDate = req?.addOnQtyDate ? moment(req?.addOnQtyDate).format('DD-MM-YYYY') : '';

            for (const contact of approvedVendorss) {
                console.log(contact.phoneNumber, 'monile no')
                const templateName = 'job_work_details'
                const message = `Unit Name: ${req?.unit} \\n Sub Job Name: ${req?.subJobId} \\n Division: ${req?.division} \\n Buyer: ${req?.buyer} \\n Add On Date: ${addOnQtyDate} \\n Add On Order Quantity: ${req?.addonOrderQty} \\n Item No: ${req?.itemNo} \\n Style No: ${req?.styleNo} \\n No Of Operations: ${req?.noOfOperations} \\n Operation Type: ${req?.operationType} \\n Rate Per Garment: ${req?.ratePerGarment} \\n Total Order Quantity : ${req.totalOrderQty}`;
                console.log(message, 'popopooiu')
                messageStatus = await this.wpService.appeCommonTemplete(Number(contact.phoneNumber), message.trim(), templateName);
                if (messageStatus?.status) {
                    statusFlag = true
                } else {
                    statusFlag = false;
                }
            }
            await transactionalEntityManager.completeTransaction();
            return new CommonResponseModel(true, 1, 'Created successfully', savedJobwork);

        } catch (err) {
            await transactionalEntityManager.releaseTransaction();
            throw err;
        }
    }

    async updateJobworkCreation(req: CreateJobworkDto): Promise<CommonResponseModel> {
        const transactionalEntityManager = new GenericTransactionManager(this.dataSource);
        try {
            await transactionalEntityManager.startTransaction();
            const existingJobwork = await transactionalEntityManager.getRepository(JobworkCreationEntity).findOne({ where: { jobworkId: req.jobworkId } });

            if (!existingJobwork) {
                return new CommonResponseModel(false, 0, 'Job work does not exist', []);
            }

            const formattedDate = moment(req.addOnQtyDate).format('YYYY-MM-DD');
            const addOnQtyDate = new Date(formattedDate);

            const updateResult = await await transactionalEntityManager.getRepository(JobworkCreationEntity).update(
                { jobworkId: req.jobworkId },
                {
                    unit: req.unit,
                    subJobId: req.subJobId,
                    division: req.division,
                    buyer: req.buyer,
                    addOnQtyDate: addOnQtyDate,
                    addonOrderQty: req.addonOrderQty,
                    itemNo: req.itemNo,
                    styleNo: req.styleNo,
                    noOfOperations: req.noOfOperations,
                    operationType: req.operationType,
                    ratePerGarment: req.ratePerGarment,
                    totalOrderQty: req.totalOrderQty,
                    createdUser: req.createdUser,
                    versionFlag: req.versionFlag,
                    updatedUser: req.updatedUser
                }
            );
            if (updateResult.affected > 0) {
                // const relatedPriceNegotiations = await transactionalEntityManager.getRepository(PriceNegotiationEntity).find({
                //     where: { jobworkId: existingJobwork }
                // });

                // for (const negotiation of relatedPriceNegotiations) {
                //     negotiation.shahiPrice = req.ratePerGarment;
                //     await transactionalEntityManager.getRepository(PriceNegotiationEntity).save(negotiation);
                // }
                await transactionalEntityManager.completeTransaction();
                return new CommonResponseModel(true, 11, 'Updated successfully, including price negotiations', updateResult);
            } else {
                return new CommonResponseModel(false, 11, 'Update failed', []);
            }
        } catch (error) {
            await transactionalEntityManager.releaseTransaction();
            throw new Error(`Update failed: ${error.message}`);
        }
    }



    async getAllJobworkCreationData(): Promise<CommonResponseModel> {
        try {
            const data = await this.jobworkCreationRepository
                .createQueryBuilder('jobwork')
                .leftJoinAndSelect('UnitsData', 'units', 'units.unitId = jobwork.unit')
                .leftJoinAndSelect('JobWorkEntity', 'job', 'job.id = jobwork.subJobId')
                .select([
                    'jobwork.jobworkId AS jobworkId',
                    'jobwork.division AS division',
                    'units.unitName AS unit',
                    'units.unit_id AS UnitsDataService',
                    'job.name AS subJobId',
                    'job.id AS jobId',
                    'jobwork.buyer AS buyer',
                    'jobwork.operationType AS operationType',
                    'jobwork.styleNo AS styleNo',
                    'jobwork.itemNo AS itemNo',
                    'jobwork.addonOrderQty AS addonOrderQty',
                    'jobwork.totalOrderQty AS totalOrderQty',
                    'jobwork.addOnQtyDate AS addOnQtyDate',
                    'jobwork.noOfOperations AS noOfOperations',
                    'jobwork.ratePerGarment AS ratePerGarment'
                ])
                .getRawMany();

            if (data && data.length > 0) {
                return new CommonResponseModel(true, 1, 'Data Retrieved', data);
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found');
            }
        } catch (error) {
            console.error('Error fetching jobwork data:', error);
            throw error;
        }
    }

    async getVendorPrice(req: VendorReq): Promise<CommonResponseModel> {
        try {
            const priceNegotiationEntity = await this.priceNegotiationRepository.findOne({ where: { id: req.id } });

            if (!priceNegotiationEntity) {
                return new CommonResponseModel(false, 0, 'Price negotiation record not found', []);
            }

            if (req.vendorPrice !== undefined && req.vendorPrice !== null) {
                priceNegotiationEntity.vendorPrice = req.vendorPrice;
            }

            if (priceNegotiationEntity.vendorPrice === priceNegotiationEntity.shahiPrice) {
                priceNegotiationEntity.finalPrice = priceNegotiationEntity.vendorPrice;
            } else {
                priceNegotiationEntity.finalPrice = 0;
            }

            priceNegotiationEntity.vendorAccepted = (priceNegotiationEntity.finalPrice === priceNegotiationEntity.shahiPrice);


            const updatedEntity = await this.priceNegotiationRepository.save(priceNegotiationEntity);

            return new CommonResponseModel(true, 1, 'Price negotiation updated successfully', updatedEntity);
        } catch (error) {
            console.error(`Error updating price negotiation: ${error.message}`);
            throw new Error(`Error updating price negotiation: ${error.message}`);
        }
    }

    async getAllVendorsData(): Promise<CommonResponseModel> {
        try {
            const vendorsData = await this.priceNegotiationRepository.find({
                relations: ['jobworkId']
            })
            if (vendorsData) {
                return new CommonResponseModel(true, 1, "Data Retrived", vendorsData);
            } else {
                return new CommonResponseModel(false, 0, "Error while retriving data");
            }
        } catch (error) {
            throw error
        }
    }

    async updateAcceptOrRejectStatus(req: VendorStatusUpdateReq): Promise<CommonResponseModel> {
        try {
            const status = await this.priceNegotiationRepository.findOne({ where: { id: req.id } });
            if (!status) {
                return new CommonResponseModel(false, 0, "Error occurs while updating status");
            }

            status.jobWorkStatus = req.jobWorkStatus;
            await this.priceNegotiationRepository.save(status);

            const manager = this.dataSource;
            const query = `SELECT jwc.sub_job_id, jwc.operation_type AS operationType, vr.phone_number, jw.name
                           FROM job_work_creation jwc
                           LEFT JOIN price_negotiation pn ON pn.jobwork_id = jwc.job_work_id
                           LEFT JOIN vendor_registration vr ON vr.id = pn.vendor_id
                           LEFT JOIN job_work jw ON jw.id = jwc.sub_job_id
                           WHERE vendor_id = '${req.vendorId}'`;

            const whatsAppData = await manager.query(query);
            const statusMessage = req.jobWorkStatus === JobWorkStatus.ACCEPTED
                ? "accepted. We look forward to your continued collaboration."
                : "rejected. Thank you.";

            let statusFlag = await this.sendWhatsAppMessages(whatsAppData, statusMessage);

            return new CommonResponseModel(true, 1, "Status updated successfully", status);
        } catch (error) {
            throw error;
        }
    }

    async sendWhatsAppMessages(contacts: any[], statusMessage: string): Promise<boolean> {
        let statusFlag = false;
        for (const contact of contacts) {
            const templateName = 'job_work_details';
            const message = `Dear Vendor, your Job Work request for the operation type ${contact.operationType} under Sub Job Work ${contact.name} has been successfully ${statusMessage}`;
            const messageStatus: any = await this.wpService.appeCommonTemplete(Number(contact.phone_number), message.trim(), templateName);
            statusFlag = messageStatus?.status ? true : false;
        }
        return statusFlag;
    }


    async getJobworkFormDataById(req: JobworkIdReq): Promise<any> {
        try {
            const result = await this.jobworkCreationRepository
                .createQueryBuilder('jwc')
                .select([
                    'jwc.division',
                    'jwc.unit',
                    'jwc.sub_job_id',
                    'jwc.buyer',
                    'jwc.operation_type',
                    'jwc.style_no',
                    'jwc.item_no',
                    'jwc.addon_order_qty',
                    'jwc.total_order_qty',
                    'jwc.add_on_qty_date',
                    'jwc.no_of_operations',
                    'jwc.rate_per_garment',
                    'vr.vendor_name',
                    'vr.contact_person_name',
                    'vr.phone_number',
                    'vr.address'
                ])
                .leftJoin('price_negotiation', 'pn', 'pn.jobwork_id = jwc.job_work_id')
                .leftJoin('vendor_registration', 'vr', 'vr.id = pn.vendor_id')
                .where('vr.id = :vendorId', { vendorId: req.vendorId })
                .andWhere('pn.jobwork_id = :jobworkId', { jobworkId: req.jobworkId })
                .getRawOne();

            return result;
        } catch (error) {
            throw new Error(`Failed to fetch jobwork form data: ${error.message}`);
        }
    }
}
